module.exports = __webpack_public_path__ + "img/seta-left.92cff479.svg";